import styled from "styled-components";
import {useSelector} from "react-redux"
import { useState, useEffect } from "react";
import axios from "axios";
import { url, setHeaders } from "../../../features/api";
import moment from "moment";
const AllTimeData = () => {
    const{items}=useSelector(state=>state.products)
    const [orders, setOrders] = useState([]);
  const [isloading, setIsloading] = useState(true);
   const [users, setUsers] = useState([]);
  const Totalsales = orders.reduce((sum, order)=>{
    return sum + order.total;
},0);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(`${url}/users/Totalusers`, setHeaders());
        setUsers(res.data);
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(`${url}/users/?new=true`, setHeaders());

        setOrders(res.data);
        setIsloading(false);
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);
  return (
    <Main>
      <h3> All Transactions</h3>
      <Info>
        <Title>Users</Title>
        <Data>{users.length}</Data>
      </Info>
      <Info>
        <Title> Products</Title>
        <Data>{items.length}</Data>
      </Info>
      <Info>
        <Title>Orders</Title>
        <Data>{orders.length}</Data>
      </Info>
       <Info>
        <Title>Earnings</Title>
        <Data>${Totalsales/100}</Data>
      </Info>
    </Main>
  );
};

export default AllTimeData;
const Main = styled.div`
  background: rgb(48, 51, 78);
  color: rgba(234, 234, 255, 0.87);
  border-radius: 5px;
  margin-top: 1.5rem;
  padding: 1rem;
  font-size: 14px;
`;
const Info = styled.div`
  display: flex;
  margin-top: 1rem;
  padding: 0.3rem;
  border-radius: 3px;
  background: rgba(38, 198, 249, 0.12);
  &:nth-child(even) {
    background: rgba(102, 108, 255, 0.12);
  }
`;
const Title = styled.div`
  flex: 1;
`;
const Data = styled.div`
  flex: 1;
  font-weight: 700;
`;
